import { Component, Input } from '@angular/core';

/**
 * GetYourGuide's "icon tile + title + subtitle" fact row (Android `FactRow`). Rendered by the caller
 * only when the underlying API field exists, so the screen never pads itself with empty rows.
 *
 * `highlightIcon` is the ONE sanctioned use of `--attr-highlight`: an urgency cue on the icon only
 * (the "likely to sell out" flame). At 3.18:1 it clears the 3:1 UI bar but fails AA for text, so it
 * must never tint the title/subtitle.
 */
@Component({
    selector: 'app-attraction-fact-row',
    template: `
    <div class="attr-fact">
      <div class="attr-fact-icon" [class.highlight]="highlightIcon">
        <app-attr-icon [name]="icon" [size]="22"></app-attr-icon>
      </div>
      <div class="attr-fact-text">
        <div class="attr-fact-title">{{ title }}</div>
        <div class="attr-fact-subtitle" *ngIf="subtitle">{{ subtitle }}</div>
      </div>
    </div>
  `,
    styles: [`
    :host { display: block; }
    .attr-fact {
      display: flex;
      align-items: flex-start;
      gap: 14px;
      padding: 8px 20px;
    }
    .attr-fact-icon {
      flex: 0 0 auto;
      width: 44px;
      height: 44px;
      border-radius: 12px;
      background: var(--attr-surface-variant, #F1F3F5);
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--attr-on-surface, #1A2B49);
    }
    .attr-fact-icon.highlight { color: var(--attr-highlight, #FF5533); }
    .attr-fact-text { min-width: 0; padding-top: 2px; }
    .attr-fact-title {
      font-size: 16px;
      font-weight: 600;
      color: var(--attr-on-surface, #1A2B49);
    }
    .attr-fact-subtitle {
      margin-top: 2px;
      font-size: 14px;
      color: var(--attr-on-surface-variant, #5A6B84);
      white-space: pre-line;
    }
  `],
    host: { class: 'attractions-scope' },
    standalone: false
})
export class AttractionFactRowComponent {
  @Input() icon = '';
  @Input() title = '';
  @Input() subtitle: string | null = null;
  @Input() highlightIcon = false;
}
